<template>
    <v-autocomplete
       :value="selected_host"
       v-bind:items="filteredHosts"
       item-value="code"
       item-text="description"
       :label="label"
       :dense="isDense"
       :clearable="isClearable"
       :multiple="isMultiple"
       :disable-lookup="true"
       @change="updateData">
       <template v-if="isMultiple" v-slot:selection="{ item, index }">
            <v-chip v-if="index < 4" small>{{ item.description }}</v-chip>
            <span v-if="index === 4" class="grey--text text-caption ml-1">(+{{ selected_host.length - 4 }} more)</span>
        </template>
       <template v-slot:prepend-item>
            <v-list-item>
                <v-list-item-content>
                    <v-text-field v-model="searchHost" placeholder="Search" :clearable="true" :autofocus="true"></v-text-field>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
        </template>       
    </v-autocomplete>
</template>

<script>
export default {
    props: {
        selected_host: {
            type: [String, Array],
            default: ''
        },
        isMultiple: {
            type: Boolean,
            default: false
        },              
        label: String,
        field: {
            type: String,
            default: 'eign_code',
        },
        isClearable:{
            type: Boolean,
            default: false
        }, 
        isDense:{
            type: Boolean,
            default: true
        }
    },
    created() {
        this.getEign();
    },    
    data() {
        return {
            hosts: [],
            searchHost: ''
        }
    },    
    computed:{
      filteredHosts(){
        let owners = this.hosts
        if(this.searchHost){
          owners = owners.filter(x => {
            return x.description.toLowerCase().indexOf(this.searchHost.toLowerCase()) > -1;
          })
        }
        return owners
      }
    },    
    methods: {
        getEign() {
            this.$axios
                .post("ares/json/ares/eign/getEignList.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getEign"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log('error', res.data.error.message);
                    } else {
                        this.hosts = res.data.getEign;
                    }
                })
        },
        updateData(v){
            // the prop must be updated. You cannot do it directly 
            // so you must update the parent field with an emit
            this.$emit('updateData', { "field": this.field, "value": v === null || (Array.isArray(v) && v.length === 0) ? (this.isMultiple ? [] : '') : v })
            if (!this.isMultiple) this.searchHost = ''; // reset search field (not for multiselect — would reinitialize the list)
        }
    }
}

</script>